export const passwordValidator = (value) => {
  if (/^(?=.*[A-z])(?=.*\d).{8,}$/.test(value)) {
    return true
  }
  return '8 caracteres mínimo, con al menos una letra y un número'
}
